import React from 'react';
import {Button} from '@mui/material';
import {Sync} from '@mui/icons-material';
import ButtonDialog from 'components/forms/ButtonDialog';
import {useMutate} from 'hooks/useFetchData';
import {useDialogContext} from 'components/dialog/DialogContext';
import {toast} from 'react-toastify';
import auth from 'services/auth';

const ConfirmPullCorosActivitiesButton = () => {
  const [mutate, mutationResult] = useMutate<{pullCorosActivities: number}>('pull', 'CorosActivities');
  const loading = mutationResult?.loading ?? false;
  const {close} = useDialogContext();
  const handlePull = () => {
    if (typeof mutate !== 'function') {
      return;
    }
    mutate()
      .then((result) => {
        const stored = result.data?.pullCorosActivities ?? 0;
        close();
        toast.success(stored > 0 ? `Stored ${stored} COROS activities.` : 'No new COROS activities.');
      })
      .catch((error) => {
        if (error.message) {
          toast.error(error.message);
        }
      });
  };
  return (
    <Button variant="contained" onClick={handlePull} disabled={loading}>
      Pull activities
    </Button>
  );
};

const PullCorosActivitiesButton = () => {
  if (!auth.isAdmin()) {
    return null;
  }

  return (
    <ButtonDialog
      buttonLabel="Pull COROS"
      variant="text"
      maxWidth="sm"
      startIcon={<Sync />}
      dialogTitle="Pull COROS activities"
      primaryButton={<ConfirmPullCorosActivitiesButton />}
    >
      Pull the latest COROS activities now?
    </ButtonDialog>
  );
};

export default PullCorosActivitiesButton;
